"use strict";

import {
  collectionSortBy,
  performSearch,
  toggleLiveSearch,
} from "./handlers";

let typingTimer;
const doneTypingInterval = 300;

export const init = () => {
  const body = document.querySelector("body");
  const overlay = document.querySelector(".overlay");
  const searchResultsContainer = document.querySelector(
    ".live-search__results",
  );
  const searchWidget = document.querySelector(".search-widget");
  const searchTrigger = document.querySelectorAll("[data-search-trigger]");
  const searchTrigger2 = document.querySelector(
    '[data-template="search"] [data-search-trigger]',
  );
  const searchClose = document.querySelectorAll("[data-search-close]");
  const searchClear = document.querySelector(".search-form__reset");
  const searchInput = document.querySelectorAll("[data-search-input]");
  const liveSearchInput = document.querySelector(
    ".header [data-search-input]",
  );
  const scrollLeftPerks = document.querySelector(
    ".scroll-perks.arrow-left",
  );
  const scrollRightPerks = document.querySelector(
    ".scroll-perks.arrow-right",
  );
  const scrollPerksList = document.querySelector(
    ".careers-block-perks-list",
  );
  const scrollLeftExecutives = document.querySelector(
    ".scroll-executives.arrow-left",
  );
  const scrollRightExecutives = document.querySelector(
    ".scroll-executives.arrow-right",
  );
  const scrollExecutivesList = document.querySelector(
    ".careers-block-our-executives-list",
  );
  const scrollLeftBestseller = document.querySelector(
    ".scroll-bestseller.arrow-left",
  );
  const scrollRightBestseller = document.querySelector(
    ".scroll-bestseller.arrow-right",
  );
  const scrollBestsellersList = document.querySelector(
    ".product-bestseller-list",
  );
  const collectionSort = document.querySelector("#collection-sort");

  // Store top content for search reset
  if (searchResultsContainer) {
    searchResultsContainer._topContent = searchResultsContainer.innerHTML;
  }

  const triggerSearch = (queryString) => {
    if (!searchResultsContainer) return;
    searchResultsContainer.style.visibility = "visible";

    if (queryString.length > 2) {
      clearTimeout(typingTimer);
      typingTimer = setTimeout(function () {
        performSearch(queryString, "relevance", searchResultsContainer);
      }, doneTypingInterval);

      if (searchClear) searchClear.style.display = "block";
    } else {
      searchResultsContainer.innerHTML =
        searchResultsContainer._topContent || "";
      if (searchClear) searchClear.style.display = "none";
    }
  };

  // Search trigger buttons
  if (searchTrigger && searchWidget) {
    searchTrigger.forEach((btn) => {
      btn.onclick = (e) => {
        e.preventDefault();
        toggleLiveSearch(body, searchWidget, searchInput);
      };
    });
  }

  // Search page trigger (scroll to results)
  if (searchTrigger2) {
    searchTrigger2.addEventListener("click", (e) => {
      e.preventDefault();
      document.getElementById("search-results-page").scrollIntoView({
        behavior: "smooth",
      });
    });
  }

  // Close buttons
  if (searchClose) {
    searchClose.forEach((btn) => {
      btn.onclick = (e) => {
        e.preventDefault();
        toggleLiveSearch(body, searchWidget, searchInput);
      };
    });
  }

  // Overlay click closes search
  if (overlay && searchWidget) {
    overlay.addEventListener("click", (e) => {
      if (searchWidget.classList.contains("is-active")) {
        e.preventDefault();
        toggleLiveSearch(body, searchWidget, searchInput);
      }
    });
  }

  // Search clear button
  if (searchClear) {
    searchClear.addEventListener("click", () => {
      searchClear.style.display = "none";
      triggerSearch("");
    });
  }

  // Live search input
  if (liveSearchInput) {
    liveSearchInput.addEventListener("keyup", (e) => {
      e.preventDefault();
      triggerSearch(e.target.value);
    });
  }

  // Collection sort (use jQuery — Chosen.js fires jQuery change, not native)
  if (collectionSort) {
    $(collectionSort).on("change", function () {
      const [sortField, direction] = this.value.split(":");
      collectionSortBy(sortField, direction);
    });
  }

  // Horizontal scroll controls — Perks
  if (scrollPerksList) {
    if (scrollRightPerks) {
      scrollRightPerks.addEventListener("click", () => {
        scrollPerksList.scroll({
          left: scrollPerksList.scrollLeft + 326,
          behavior: "smooth",
        });
      });
    }
    if (scrollLeftPerks) {
      scrollLeftPerks.addEventListener("click", () => {
        scrollPerksList.scroll({
          left: scrollPerksList.scrollLeft - 326,
          behavior: "smooth",
        });
      });
    }
  }

  // Horizontal scroll controls — Executives
  if (scrollExecutivesList) {
    if (scrollRightExecutives) {
      scrollRightExecutives.addEventListener("click", () => {
        scrollExecutivesList.scroll({
          left: scrollExecutivesList.scrollLeft + 700,
          behavior: "smooth",
        });
      });
    }
    if (scrollLeftExecutives) {
      scrollLeftExecutives.addEventListener("click", () => {
        scrollExecutivesList.scroll({
          left: scrollExecutivesList.scrollLeft - 700,
          behavior: "smooth",
        });
      });
    }
  }

  // Horizontal scroll controls — Bestsellers
  if (scrollBestsellersList) {
    if (scrollRightBestseller) {
      scrollRightBestseller.addEventListener("click", () => {
        scrollBestsellersList.scroll({
          left: scrollBestsellersList.scrollLeft + 700,
          behavior: "smooth",
        });
      });
    }
    if (scrollLeftBestseller) {
      scrollLeftBestseller.addEventListener("click", () => {
        scrollBestsellersList.scroll({
          left: scrollBestsellersList.scrollLeft - 700,
          behavior: "smooth",
        });
      });
    }
  }
};
